import React from 'react'

function StaticOverviewTableThead(props) {
    return (
        <thead className='StaticOverviewTableThead'>
            <tr>
                <th className="Name">Nhân viên</th>
                <th className="StaticCol">In</th>
                <th className="StaticCol">Cắt</th>
                <th className="StaticCol">Khắc</th>
                <th className="StaticCol">Hoàn thiện</th>
                <th className="StaticCol">QC hoàn thành</th>
                <th className="StaticCol">Đóng gói</th>
                <th className="StaticCol">Dán label</th>
                <th className="StaticCol">Đóng thùng</th>
                <th className="StaticCol">Chụp ảnh sản phẩm</th>
                <th className="StaticCol">Đánh dấu lỗi</th>
            </tr>
        </thead>
    )
}

export default StaticOverviewTableThead
